import { render, staticRenderFns } from "./ClienteCard.vue?vue&type=template&id=fd024e10&scoped=true"
import script from "./ClienteCard.vue?vue&type=script&lang=js"
export * from "./ClienteCard.vue?vue&type=script&lang=js"
import style0 from "./ClienteCard.vue?vue&type=style&index=0&id=fd024e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd024e10",
  null
  
)

export default component.exports